import { render, staticRenderFns } from "./Government_receipt_edit.vue?vue&type=template&id=5c19bba7&scoped=true&"
import script from "./Government_receipt_edit.vue?vue&type=script&lang=js&"
export * from "./Government_receipt_edit.vue?vue&type=script&lang=js&"
import style0 from "./Government_receipt_edit.vue?vue&type=style&index=0&id=5c19bba7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19bba7",
  null
  
)

export default component.exports